<template>
<div>
  <ModalBanner
    :modalActive="modalBannerActive"
    :modalImages="modalImages"
    :slideIndex='slideIndex'
    @update:close="modalBannerActive = $event"
  >
  </ModalBanner>
  <section class="pt-24 bd-t-1 bd-gray-300-brand section-itinerary" v-if='dataTrip' :style="mapStyleTimelineIcon()">
    <div class="flex justify-between items-center mb-15">
      <h2 class="heading-4-bd">Itinerary</h2>
      <!-- "Customise This Trip" was a mobile-only CTA here — hidden per request. The Expand/Hide
           All Days toggle keeps its prior visibility (desktop + bookable trips); mobile gallery
           trips (where the CTA used to sit) now show no button in this header. -->
      <DJButton
        v-if="!($device.isMobile && showCustomButton)"
        type="tertiary"
        title="ExpandAllItems"
        aria-label="ExpandAllItems"
        @click="toggleExpandAll"
      >
        {{ !expandAll ? 'Expand All Days' : 'Hide All Days' }}
      </DJButton>
    </div>
    <CollapseGroup
      :toggleAllPanelExpand="expandAll"
      groupName="timeline"
      isTimeline
      class="trip-plan"
    >
      <Collapse
        :expanded="defaultExpand()"
        :triggerExpand="itemDefaultExpend.includes(i)"
        :index="i"
        v-for="(item, i) in dataTrip.itinerary"
        @heap-track="toogleSingleExpand(item, i)"
        :key="i"
        :class="{
          first: i === 0,
          last: dataTrip.itinerary.length > 1 && i === dataTrip.itinerary.length - 1,
        }"
      >
        <template #title>
          <small class="dib mb-6 fw-700 gray-dark fs-14 lh-15"
            >Day {{ item.day }}</small
          >
          <h3 class="fs-18 lh-22 fw-700" v-if="item.title">{{ item.title }}</h3>
          <div v-if='item.date_fmt' class='gray-dark fs-14 lh-14 mt-8'>{{item.date_fmt}}</div>
        </template>
        <template #icon> <span class="text-sm-sb">View details</span> </template>
        <template #icon-expanded> <span class="text-sm-sb brand-950">Close</span> </template>
        <template #content>
          <div class="mb-0 wp-100 db clearfix">
            <div class="preview relative br-12 overflow-hidden mr-30 mb-10 mb-mb-10 mb-mr-0 z-2 fl mb-fn" v-if="!isSimplified && !isEmpty(item.feature_image)">
              <div class="wp-100 hp-100 br-12 overflow-hidden relative z-1 hand" @click="toggleModalBanner(item.images)">
                <BaseResponsiveImages :src="item.feature_image" :alt="item.title" customImgClass='br-12 overflow-hidden' />
              </div>
              <button
                class="button-glass px-11 py-8 br-8 white fs-14 lh-18 fw-700 flex items-center absolute bottom-12 right-12 hand"
                @click="toggleModalBanner(item.images)"
                v-if="!isEmpty(item.images) && item.images.length > 1"
              >
                <img
                  :src="`${$assetsCdn}/icons/icon-thumbnail.svg`"
                  alt="image"

                />
                <span class="ml-8">See All Photos</span>
              </button>
            </div>
            <p v-html="nl2br(item.overview)"></p>
          </div>
          <ul class="mt-20">
            <li class="mb-20 flex items-start" v-if="item.accommodation && isSimplified">
              <img :src="`${$assetsCdn}/images/tripplan/icon-hotel.svg`" alt="accommodation icon" />
              <div class="ml-5">
                <h5 class="fs-14 lh-18 fw-600">Accommodation</h5>
                <p class="fs-14 lh-18 mb-0" v-html="item?.accommodation"></p>
              </div>
            </li>
            <li class="mb-20 flex items-start" v-if="item.simplified_itinerary && isSimplified">
              <img :src="`${ASSETS_CDN}/icons/itinerary.svg`" alt="itinerary icon" />
              <div class="ml-5">
                <h5 class="fs-14 lh-18 fw-600">Itinerary</h5>
                <p class="fs-14 lh-18 mb-0" v-html="item?.simplified_itinerary"></p>
              </div>
            </li>
            <li
              class="mb-20 flex items-start"
              v-if="item.accommodations.length && !isSimplified"
            >
              <img :src="`${$assetsCdn}/images/tripplan/icon-hotel.svg`" alt="accommodation icon" />
              <div class="ml-5">
                <h5 class="fs-14 lh-18 fw-600">Accommodation</h5>
                <p
                  class="fs-14 lh-18 mb-0"
                  v-for="(value, i) in item.accommodations"
                  :data-start-time="value.start_time"
                  :data-end-time="value.end_time"
                  :data-id="value.item_id"
                  :key="i"
                >
                  <span
                    class="underline hand ttc"
                    @click="openAccomModal(value.item_id)"
                    >
<!--                    <router-link class='pointer-none' :to='{path: $route.path, query: {accommodation: value.item_id}}'>{{ value.name }}</router-link>-->
                    {{ value.name }}
                  </span>
                  <span class="ml-10">
                    <span class="dib" v-if="hasAccmRating(value)">
                      <span class="yellow fs-15 mr-4 dib">★</span>
                      <span class="fs-12 gray-dark lh-14"
                        >{{ value.rating }} star</span>
                    </span>
                    <span v-if="hasAccmRating(value) && value.price_included === 2 || hasAccmRating(value) && value.price_included === 0" class='dib pl-5 pr-5 gray-dark'>/</span>
                    <span>
                      <span class="fs-12 gray-dark lh-14" >
                        {{getOptionText(value)}}<template v-if='value.cost_per_person > 0'>:&nbsp;{{currencyDisplay}} <CalculatorDisplayPrice :originalPrice='value.cost_per_person'/> per person</template>
                      </span>
                    </span>
                  </span>
                </p>
              </div>
            </li>
            <li
              class="mb-20 flex items-start"
              v-if="item.activities.length && !isSimplified"
            >
              <img :src="`${$assetsCdn}/images/tripplan/icon-hiking.svg`" alt="activities icon" />
              <div class="ml-5">
                <h5 class="fs-14 lh-18 fw-600">Activities</h5>
                <p
                  class="fs-14 lh-18 mb-0"
                  v-for="(value, i) in item.activities"
                  :key="i"
                >
                  <span
                    class="underline hand ttc"
                    @click="openActivityModal(value.item_id)"
                    >
<!--                    <router-link class='pointer-none' :to='{path: $route.path, query: {activity: value.item_id}}'>{{ value.name }}</router-link>-->
                    {{ value.name }}
                  </span>
                  <span class="ml-10">
                    <span class="fs-12 gray-dark lh-14" >
                      {{getOptionText(value)}}<template v-if='value.cost_per_person > 0'>:&nbsp;{{currencyDisplay}} <CalculatorDisplayPrice :originalPrice='value.cost_per_person'/> per person</template>
                    </span>
                  </span>
                </p>
              </div>
            </li>
            <li
              class="mb-20 flex items-start"
              v-if="item.restaurants.length && !isSimplified"
            >
              <img :src="`${$assetsCdn}/images/tripplan/icon-restaurant.svg`" alt="restaurant icon" />
              <div class="ml-5">
                <h5 class="fs-14 lh-18 fw-600">Restaurants</h5>
                <p
                  class="fs-14 lh-18 mb-0"
                  v-for="(value, i) in item.restaurants"
                  :key="i"
                >
                  <span
                    class="underline hand ttc"
                    @click="openRestaurantModal(value.item_id)"
                    >
<!--                    <router-link class='pointer-none' :to='{path: $route.path, query: {restaurant: value.item_id}}'>{{ value.name }}</router-link>-->
                    {{ value.name }}
                  </span>
                  <span class="ml-10">
                    <span class="fs-12 gray-dark lh-14" >
                      {{getOptionText(value)}}<template v-if='value.cost_per_person > 0'>:&nbsp;{{currencyDisplay}} <CalculatorDisplayPrice :originalPrice='value.cost_per_person'/> per person</template>
                    </span>
                  </span>
                </p>
              </div>
            </li>
            <li
              class="mb-20 flex items-start"
              v-if="item.transportations.length && !isSimplified"
            >
              <img :src="`${$assetsCdn}/images/tripplan/icon-bus.svg`" alt="transportations icon" />
              <div class="ml-5">
                <h5 class="fs-14 lh-18 fw-600">Transportations</h5>
                <p
                  class="fs-14 lh-18 mb-0"
                  v-for="(value, i) in item.transportations"
                  :key="i"
                >
                  <span
                    class="underline hand ttc"
                    @click="openTransportationModal(value.item_id)"
                    >
<!--                    <router-link class='pointer-none' :to='{path: $route.path, query: {transportation: value.item_id}}'>{{ value.name }} {{ value.description }}</router-link>-->
                    {{ value.name }} {{ value.description }}
                  </span>

                  <span class="ml-10">
                    <span class="fs-12 gray-dark lh-14" >
                      {{getOptionText(value)}}<template v-if='value.cost_per_person > 0'>:&nbsp;{{currencyDisplay}} <CalculatorDisplayPrice :originalPrice='value.cost_per_person'/> per person</template>
                    </span>
                  </span>
                </p>
              </div>
            </li>
            <li class="mb-20 flex items-start" v-if="item.meals">
              <img :src="`${$assetsCdn}/images/tripplan/icon-catering.svg`" alt="meals icon" />
              <div class="ml-5">
                <h5 class="fs-14 lh-18 fw-600">Meals</h5>
                <p class="fs-14 lh-18 mb-0">{{ item.meals }}</p>
              </div>
            </li>
            <li
              class="mb-20 flex items-start"
              v-if="item.destinations.length && !isSimplified"
            >
              <img :src="`${$assetsCdn}/images/tripplan/icon-local.svg`" alt="destination icon" />
              <div class="ml-5">
                <h5 class="fs-14 lh-18 fw-600">Destinations</h5>
                <p
                  class="fs-14 lh-18 mb-0"
                  v-for="(value, i) in item.destinations"
                  :key="i"
                >
                  {{ value }}
                </p>
              </div>
            </li>
            <li
              class="flex items-start"
              v-if="item.notes.length && !isSimplified"
            >
              <img :src="`${$assetsCdn}/images/tripplan/icon-notes.svg`" alt="notes icon" />
              <div class="ml-5">
                <h5 class="fs-14 lh-18 fw-600">Notes</h5>
                <p
                  class="fs-14 lh-18"
                  v-for="(value, i) in item.notes"
                  :key="i"
                >
                  <span class="fs-14 lh-18" v-if="value.description || value.name">
                    {{ value.description ? value.description : value.name }}
                  </span>
                </p>
              </div>
            </li>
          </ul>
        </template>
      </Collapse>
    </CollapseGroup>
    <div v-if="!dataTrip.is_booked && !isTripPlan" class="trip-note bg-yellow-50 py-16 px-16 br-14 mt-16">
        <h3 class="text-md-sb yellow-700">Note</h3>
        <p class="mb-0 text-sm-rg">
          We will endeavour to book the hotels mentioned above. If, however, we are unable to secure them due to circumstances out of our control, we will
          replace them with hotels of similar value and standard. Confirm Now to make the reservations.
        </p>
      </div>
  </section>
  <client-only>
    <PopupCommon
    :modalTitle="modalProductTitle"
    :modalActive="modalProductActive"
    @update:close="modalProductActive = $event"
    :maxWidth="'600'"
    :modalHeight="modalProductHeight"
  >
    <template #carousel>
      <div
        v-if="productItem.images && productItem.images.length > 1"
        class="product-slider mb-h-250 h-300"
      >
        <Carousel :wrap-around="true">
          <template #counter />
          <Slide v-for="(slide, index) in productItem.images" :key="index" class='mb-h-250 h-300'>
            <BaseResponsiveImages customClass='db wp-100 hp-100' :src="slide"/>
          </Slide>
          <template #addons>
            <Navigation />
          </template>
        </Carousel>
      </div>
      <div class='mb-h-250 h-300' v-else-if="productItem.images && productItem.images.length === 1">
        <BaseResponsiveImages customClass='db wp-100 hp-100'
          :src="productItem.images[0]"
        />
      </div>
    </template>
    <template #content>
      <ProductPopup @heightPopup='heightPopup' :data="productItem"/>
    </template>
  </PopupCommon>
  </client-only>
</div>
</template>

<script>
import { ref, computed, inject, nextTick, onMounted } from "vue"
import ModalBanner from '../SectionBanner/ModalBanner.vue'
import Collapse from '~/components/ui/collapse/Collapse'
import CollapseGroup from '~/components/ui/collapse/CollapseGroup'
import {assetCDN, isEmpty, nl2br, publicDomain} from '~/helper'
import BaseResponsiveImages from '~/components/ui/BaseResponsiveImages/BaseResponsiveImages'
import PopupCommon from '~/components/ui/popup/PopupCommon'
import ProductPopup from '../ProductPopup/ProductPopup'
import tripApi from '~/composables/api/tripApi'
import Slide from '~/components/ui/carousel/Slide'
import Carousel from '~/components/ui/carousel/Carousel'
import Navigation from '~/components/ui/carousel/Navigation'
import CalculatorDisplayPrice from '~/components/pages/TripPlanDetail/CalculatorDisplayPrice'
import { useRoute } from 'vue-router'
import { debounceHeapTracking } from '~/mixins/heap'
import { debounceAmplitudeScriptTracking } from '~/mixins/amplitude'
import DJButton from '~/components/ui/button/Button.vue'
import { useTripPlanStore } from '~/store/pinia/tripPlan'

export default {
  components: {
    CalculatorDisplayPrice,
    ProductPopup,
    PopupCommon,
    BaseResponsiveImages,
    ModalBanner,
    Collapse,
    CollapseGroup,
    Carousel,
    Slide,
    Navigation,
    DJButton,
  },
  data() {
    return {
      settings: {
        itemsToShow: 1,
      },
    }
  },
  props: {
    showCustomButton:{
      default: false,
      type: Boolean
    },
    itemDefaultExpend:{
      default: [0],
      type: Array
    }
  },
  emits: ['customise-trip'],
  setup(props) {
    const route = useRoute()
    const expandAll = ref(true)
    const modalBannerActive = ref(false)
    const modalImages = ref([])
    const previewStatus = ref(false)
    const previewImage = ref({})
    const modalProductActive = ref(false)
    const modalProductTitle = ref('')
    const slideIndex = ref(0)
    const productItem = ref({})
    const modalProductHeight = ref(0)
    const domain = publicDomain()
    const itemDefaultExpend = ref([])
    const ASSETS_CDN = assetCDN()
    const tripPlanStore = useTripPlanStore()

    const dataTrip = computed(() => {
      let data = {...tripPlanStore.dataTrip}

      data.itinerary = data?.itinerary?.map(function (item) {
        let time = new Date(item.date).getTime() / 1000
        let date = Math.floor(time / 86400) * 86400
        let daySnapshot = {...item}
        let accommodations = daySnapshot.accommodations.filter((item) => {
          let start_time = new Date(item.start_time).getTime() / 1000
          let start_date = Math.floor(start_time / 86400) * 86400
          let end_time = new Date(item.end_time).getTime() / 1000
          let end_date = Math.floor(end_time / 86400) * 86400
          let checkout_hour = (end_time - end_date) / 3600

          // remove accommodation if the checkout time is before 14:00pm
          if ((date == end_date) && (start_date != end_date) && (checkout_hour < 14)) {
            return false
          }

          return true
        })

        daySnapshot.accommodations = accommodations

        return daySnapshot
      })

      return data;
    })
    const isTripPlan = computed(() => route.name === 'trip-plan')

    const isSimplified = inject('isSimplified', false)
    const currencyDisplay = inject('currencyDisplay', 'AU$')

    const toggleExpandAll = () => {
      expandAll.value = !expandAll.value
      if (!expandAll.value) {
        debounceHeapTracking("Expand All Days Trip Plan", {
          number_of_day: dataTrip.value?.itinerary.length,
          number_of_activity: dataTrip.value?.itinerary?.map(item => item?.activities.length).reduce((a,b) => a+b)
        })
        debounceAmplitudeScriptTracking("Expand All Days Trip Plan", {
          number_of_day: dataTrip.value?.itinerary.length,
          number_of_activity: dataTrip.value?.itinerary?.map(item => item?.activities.length).reduce((a,b) => a+b)
        })
      }
    }

    const toogleSingleExpand = (item, index) => {
      debounceHeapTracking("View Day Details Trip Plan", {
        number_of_accommodation: item.accommodations.length,
        number_of_transportation: item.transportations.length,
        number_of_restaurant: item.restaurants.length,
        number_of_other_activity: item.activities.length,
        number_of_note: item.notes.length,
        day_number: index + 1,
        meal_inclusion: item.meals,
      })
      debounceAmplitudeScriptTracking("View Day Details Trip Plan", {
        number_of_accommodation: item.accommodations.length,
        number_of_transportation: item.transportations.length,
        number_of_restaurant: item.restaurants.length,
        number_of_other_activity: item.activities.length,
        number_of_note: item.notes.length,
        day_number: index + 1,
        meal_inclusion: item.meals,
      })
    }

    const toggleModalBannerPreview = (payload) => {
      previewStatus.value = true
      modalBannerActive.value = !modalBannerActive.value
      modalImages.value = payload
    }

    const toggleModalBanner = (images) => {
      modalBannerActive.value = !modalBannerActive.value
      modalImages.value = images
      if (!modalBannerActive.value) {
        debounceHeapTracking('See all Photos of a Trip Plan Day', {
          number_of_photos: images,
        })
        debounceAmplitudeScriptTracking('See all Photos of a Trip Plan Day', {
          number_of_photos: images,
        })
      }
    }

    const productDataStore = computed(() => tripPlanStore.product)

    // Product Type (Example: accommodation, activity, restaurant, transportation)
    const getProductData = async (productType, itemID) => {
      let prodID = dataTrip.value.id + '_' + productType + '_' + itemID
      let prodData = productDataStore.value || {}

      if (prodData[prodID]) {
        productItem.value = prodData[prodID]

        // productItem.value = prodData[prodID]
        
        tripPlanStore.setProductData(prodData)

        return
      }

      let params = {
        tripID: dataTrip.value.id,
        itemID: itemID,
      }

      try {
        const resp = await tripApi.getProductPopup(params)

        prodData[prodID] = resp.data.value?.data

        productItem.value = prodData[prodID]

        tripPlanStore.setProductData(prodData)
      } catch (e) {
        console.log(e)
        throw new Error('Get product data error (SectionTimeline) : ', { cause: e })
      }
    }

    const heapTrack = async (type) => {
      if(process.server) return
      await nextTick();
      let included;
      switch(productItem?.value?.price_included) {
        case 0:
        included = 'optional_not_included'
        break;
        case 1:
        included = 'included'
        break;
        default:
        included = 'mandatory_not_included'
      }
      debounceHeapTracking("View Activity Trip Plan", {
        activity_category: type,
        duration: productItem.value?.duration,
        place: productItem.value?.address,
        destination_country: productItem.value?.address?.split(", ")?.pop(),
        is_guide_included: !productItem.value?.type === "Not guided",
        price_inclusion: included,
      })
      debounceAmplitudeScriptTracking("View Activity Trip Plan", {
        activity_category: type,
        duration: productItem.value?.duration,
        place: productItem.value?.address,
        destination_country: productItem.value?.address?.split(", ")?.pop(),
        is_guide_included: !productItem.value?.type === "Not guided",
        price_inclusion: included,
      })
    }

    const openAccomModal = async (item) => {
      await getProductData('accommodation', item)
      await heapTrack('accommodation')
      modalProductTitle.value = 'Accommodation'
      modalProductActive.value = !modalProductActive.value
    }

    const openActivityModal = async (item) => {
      await getProductData('activity', item)
      await heapTrack('activity')
      modalProductTitle.value = 'Activity'
      modalProductActive.value = !modalProductActive.value
    }

    const openRestaurantModal = async (item) => {
      await getProductData('restaurant', item)
      await heapTrack('restaurant')
      modalProductTitle.value = 'Restaurant'
      modalProductActive.value = !modalProductActive.value
    }

    const openTransportationModal = async (item) => {
      await getProductData('transportation', item)
      await heapTrack('transportation')
      modalProductTitle.value = 'Transportation'
      modalProductActive.value = !modalProductActive.value
    }

    const hasAccmRating = (data) => {
      const rating = parseFloat(data.rating)
      return rating > 0 ? true : false
    }

    const heightPopup = (height) => {
      modalProductHeight.value = height + 593
    }

    const getOptionText = (item) => {
      /*if(item.price_included === 2 && item.cost_per_person === 0 || item.price_included === 0 && item.cost_per_person === 0) return 'not included in price'
      if(item.price_included === 2 && item.cost_per_person > 0) return 'mandatory (not included in price): '
      if(item.price_included === 0 && item.cost_per_person > 0) return 'optional (not included in price): '*/
      if(item.price_included === 2) return 'Request to Book'
      if(item.price_included === 0) return 'Optional Activity'
    }

    const defaultExpand = () => {
      return (domain === 'preview' || domain === 'traveller');
    }

    function mapStyleTimelineIcon() {
      return {
        '--dj-timeline-icon-start': `url(${ASSETS_CDN}/icons/icon-timeline-start.svg)`,
        '--dj-timeline-icon-end': `url(${ASSETS_CDN}/icons/icon-timeline-end.svg)`,
      }
    }

    onMounted(async () => {
      if(route.query.accommodation) await openAccomModal(route.query.accommodation)
      if(route.query.activity) await openActivityModal(route.query.activity)
      if(route.query.restaurant) await openRestaurantModal(route.query.restaurant)
      if(route.query.transportation) await openTransportationModal(route.query.transportation)

      setTimeout(() => {
        expandAll.value = false
        itemDefaultExpend.value = props.itemDefaultExpend
      }, 2000)
    })

    return {
      nl2br,
      dataTrip,
      isSimplified,
      previewStatus,
      previewImage,
      toggleModalBannerPreview,
      toggleModalBanner,
      modalBannerActive,
      modalImages,
      expandAll,
      isEmpty,
      openAccomModal,
      productItem,
      modalProductTitle,
      modalProductActive,
      openActivityModal,
      openTransportationModal,
      openRestaurantModal,
      hasAccmRating,
      currencyDisplay,
      modalProductHeight,
      heightPopup,
      getOptionText,
      slideIndex,
      defaultExpand,
      toggleExpandAll,
      toogleSingleExpand,
      ASSETS_CDN,
      itemDefaultExpend,
      isTripPlan,
      mapStyleTimelineIcon,
    }
  }
}
</script>

<style lang="scss" scoped>
//.button-glass {
//  position: absolute;
//  bottom: 12px;
//  right: 12px;
//  background: rgba(255, 255, 255, 0.3);
//  backdrop-filter: blur(10px);
//}
.bg-yellow-note {
  background-color: rgba(240, 196, 116, 0.1);
}
// W7 dark: the "Note" callout is bg-yellow-50 (#fffaeb near-white) + a burnt-orange yellow-700 heading —
// a glaring pale box with low-contrast text on the dark canvas. Flip to a subtle dark amber-tint panel
// (the translucent $yellow-note token reads over any dark bg), lift the heading to a brighter amber, and
// set the body to $foreground. Light untouched. (The dark guideline defines no note/callout token, so this
// reuses the existing $yellow-* accent tokens rather than inventing a dark hex.)
[data-theme='dark'] .trip-note {
  background-color: $yellow-note;
  .yellow-700 { color: $yellow-warning; }
  p { color: $foreground; }
}
.item {
  flex: 1;
  margin-right: 13px;
  &:last-child {
    margin-right: 0;
  }
}
.preview {
  width: 320px; height: 200px;
  @include phone {
    max-width: 100%;
  }
}

.product-slider {
  :deep(section.carousel) {
    .carousel__prev, .carousel__next {
      img {
        display: none;
      }
    }
  }
}
// v2 Itinerary Row States (guideline) — green-family tints; hover must never be a cool grey.
:deep(.collapse--expanded .collapse__header-inner),
:deep(.collapse--expanded .collapse__header-inner:hover) {
  background-color: $row-expanded-tint; // #E8F3EF (was brandColor(brand, 50))
}
:deep(.collapse__header-inner:hover) {
  background-color: $row-hover-tint; // #F0F4F3 (was brandColor(gray, 50) — a cool grey)
}
:deep(.collapse-group.timeline:before) {
  border-color: brandColor(gray, 300)
}

.section-itinerary {
  :deep(.timeline) {
    & .collapse.first .collapse__header::before {
      content: var(--dj-timeline-icon-start, url('#{$assets-cdn}/images/tripplan/Start.svg'));
    }
    & .collapse.last .collapse__header::before {
      content: var(--dj-timeline-icon-end, url('#{$assets-cdn}/images/tripplan/End.svg'));
    }
    & .collapse:not(.first):not(.last) .collapse__header::before {
      border: 2px solid brandColor(brand, 700);
    }
    & .collapse--expanded:not(.first):not(.last) .collapse__header::before {
      background: brandColor(brand, 700);
    }
  }
}
</style>

<!--
<style lang='scss'>
.product-slider {
  @extend %slider
  }
</style>
-->
